import React from 'react';
import styled, { keyframes } from 'styled-components';
import PrimaryButton from '@crehana/ui/dist/Buttons/PrimaryButton';
import { createUrlWithSourceQueryParams } from 'Jsx/Analytics/Amplitude';
import { SHOPPING_CART_AMPLITUDE_PAGE_NAME } from 'Jsx/ShoppingCart/constants';
import MembershipUpsell from './MembershipUpsell';

const BtnWrapper = styled.div`
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
`;

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2000;
  background-color: #fff;
  display: block;
  @media (min-width: 1024px) {
    display: none;
  }
`;

const placeHolderShimmer = keyframes`
  from {
    background-position: 100% 0
  }
  to {
    background-position: -100% 0
  }
`;

export const AbsoluteSkeleton = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeHolderShimmer};
  animation-timing-function: linear;
  background: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
`;

const Wrapper = styled.div<{ withBorder: boolean }>`
  ${props => props.withBorder && 'border-top: 1px solid rgba(0,0,0,.05);'}
`;

type StickyFooterProps = {
  promoVisibility: boolean;
  promo: any;
  hidePromo(): void;
  loadingCart: boolean;
  cartSummary: any;
  loadingCartMutation: boolean;
};

const StickyFooter = ({
  hidePromo,
  loadingCart,
  promo,
  promoVisibility,
  cartSummary,
  loadingCartMutation,
}: StickyFooterProps) => {
  const showPromo = promoVisibility && promo;
  const { totalPrice, currencySymbol, idCart } = cartSummary;

  const checkoutUrl = createUrlWithSourceQueryParams({
    url: `/payment/?shopping_cart_id=${idCart}`,
    source: SHOPPING_CART_AMPLITUDE_PAGE_NAME,
    sourceDetail: 'Sticky Footer',
  });

  return (
    <Footer className="w-full">
      {showPromo && promo && (
        <MembershipUpsell
          promo={promo}
          price={totalPrice}
          noBackground
          hidePromo={hidePromo}
        />
      )}
      <Wrapper
        withBorder={!showPromo}
        className="pt-16 pb-16 pl-24 pr-24 sm:flex sm:items-center"
      >
        <BtnWrapper className="flex items-center justify-center">
          <div className="flex items-center">
            {!loadingCart && !loadingCartMutation ? (
              <PrimaryButton
                full
                label={`Comprar por ${currencySymbol}${
                  totalPrice && totalPrice.toLocaleString()
                }`}
                href={checkoutUrl}
              />
            ) : (
              <div style={{ height: 48 }} className="relative w-full">
                <AbsoluteSkeleton />
              </div>
            )}
          </div>
        </BtnWrapper>
      </Wrapper>
    </Footer>
  );
};

export default StickyFooter;
